import React, { useEffect } from "react";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useParams } from "react-router-dom";
import { getFaqWithId } from "../../redux/templete/authSlice";

function HelpArticlesModal() {
  const { userFaq } = useSelector((state) => state.authReducer);
  const { a } = useParams();
  const id = a.split("-")[0];
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: "auth/resetDetail" });
    dispatch(getFaqWithId(id));
  }, [dispatch, id]);

  return (
    <div className="w-full py-10 max-w-[1000px]">
      <h1 className="text-[3rem] font-bold mb-4 text-black">
        Help with {userFaq && userFaq[0].category.name}
      </h1>

      <div className="flex flex-col gap-3 mb-6">
        {userFaq !== null &&
          userFaq.map((faq) => (
            <NavLink
              to={"/help/article/" + faq._id}
              className="border rounded-lg w-full  p-4 flex flex-row gap-2 items-center transition-shadow duration-200 ease-out hover:shadow-[0_2px_12px_rgba(36,63,97,0.11),0_0.5px_2px_rgba(36,63,97,0.12)]"
            >
              <span className="text-base w-[95%] overflow-hidden text-ellipsis whitespace-nowrap text-left">
                {faq.question}
              </span>
              <span className="font-semibold text-lg">
                <MdOutlineKeyboardArrowRight />
              </span>
            </NavLink>
          ))}
      </div>

      <span className=" text-lg font-bold mb-4 text-black">
        Can't find what you're looking for?
      </span>
      <div className="flex flex-col gap-3 mb-6">
        <NavLink
          to={"/contact-us"}
          className="border rounded-lg w-full  p-4 flex flex-row gap-2 items-center transition-shadow duration-200 ease-out hover:shadow-[0_2px_12px_rgba(36,63,97,0.11),0_0.5px_2px_rgba(36,63,97,0.12)]"
        >
          <span className="text-base w-[95%]">Chat with us</span>
          <span className="font-semibold text-lg">
            <MdOutlineKeyboardArrowRight />
          </span>
        </NavLink>
      </div>
    </div>
  );
}

export default HelpArticlesModal;
